import { css } from '@emotion/react'
import { graphql } from 'gatsby'
import { ComponentPropsWithoutRef } from 'react'

import { DatoStructuredText } from '@/features/common/'
import { DatoLink } from '@/features/dato-link'
import { colors } from '@/theme/variables'

interface Props extends ComponentPropsWithoutRef<'div'> {
  data: Queries.CurriculaFragment | null
}

export const Curricula = ({ data, ...props }: Props): JSX.Element => {
  const styles = {
    curricula: css`
      /* float: left; */
      padding: 0 calc(var(--margin) / 2) 3em;
      box-sizing: border-box;
    `,
    title: css`
      font-size: var(--fs-36);
      margin: 0 0 0.5em;
      &:after {
        content: '';
        display: block;
        width: 1em;
        margin-top: 0.5em;
        height: 2px;
        background: ${colors.red};
      }
    `,
    description: css``,
    link: css`
      color: ${colors.red};
      @media (hover: hover) {
        &:hover {
          color: ${colors.redDark};
        }
      }
    `,
  }
  return (
    <div
      css={styles.curricula}
      {...props}
    >
      <h3 css={styles.title}>{data?.title}</h3>
      <div css={styles.description}>
        <DatoStructuredText
          data={data?.description}
          renderBlock={({ record }) => {
            switch (record.__typename) {
              case 'DatoCmsTertiaryArticleLink': {
                return (
                  <DatoLink
                    data={record}
                    css={styles.link}
                    styleVariant="LOWERCASE"
                    showIcon
                  />
                )
              }
              default:
                return null
            }
          }}
        />
      </div>
    </div>
  )
}

export const CurriculaFragment = graphql`
  fragment Curricula on DatoCmsCurricula {
    __typename
    id: originalId
    title
    description {
      value
      blocks {
        ... on DatoCmsTertiaryArticleLink {
          ...TertiaryArticleLink
        }
      }
    }
  }
`
